/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Button_CancelInputs */



/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Spaces_Wizard_Button_CancelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_button_cancel = /** @type {((inputs?: Spaces_Wizard_Button_CancelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Button_CancelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abbrechen")
	return /** @type {LocalizedString} */ ("Cancel")
});